import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined' && window.console) {
      console.warn('App error captured:', error, info);
    }
  }

  handleReload = () => {
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: '#000',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            fontFamily: "'Nacelle', -apple-system, sans-serif",
            textAlign: 'center',
          }}
        >
          <h1 style={{ fontSize: 28, fontWeight: 600, marginBottom: 12 }}>
            Something went wrong.
          </h1>
          <p style={{ opacity: 0.65, maxWidth: 420, marginBottom: 20 }}>
            We hit a small bump. Reload the page or join the Telegram channel
            directly.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                background: '#FF6E00',
                color: '#fff',
                border: 'none',
                padding: '12px 22px',
                borderRadius: 9999,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Reload
            </button>
            <a
              href="https://t.me/+58NEU36tml5kYWY1"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                background: 'rgba(255,255,255,0.06)',
                color: '#fff',
                padding: '12px 22px',
                borderRadius: 9999,
                textDecoration: 'none',
                border: '1px solid rgba(255,255,255,0.15)',
              }}
            >
              Open Telegram
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
